import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';

import { clearPortalLogoutStorage } from './portal-auth-storage';

/**
 * Clears portal auth artifacts and triggers Auth0 logout using the app origin.
 * Use this helper for every portal logout path to keep behavior consistent.
 */
export function logoutPortalUser(auth: AuthService, doc: Document): Observable<void> {
  clearPortalLogoutStorage(doc.defaultView?.localStorage ?? localStorage);
  return auth.logout({
    logoutParams: {
      returnTo: doc.location.origin,
    },
  });
}
